<template>
  <tr @click = "select" @keydown.enter.prevent.stop = "select">
    <slot />
  </tr>
</template>
<script lang = "babel">
  export default{
    name: 'SelectableGridRow',

    props: {
      activeRow: Number
    },

    methods: {
      select () {
        this.$emit('select')
      }
    },

    created () {
      this.$on('activated', (data) => {
        this.$parent.$emit('activated', data)
      })
    }
  }
</script>



// WEBPACK FOOTER //
// SelectableGridRow.vue?41e59a52